import { fetchWithCSRF } from "../utils/xhrConfig";
import { getTimePickerValue } from "../utils/timepicker";
import { handleSubmitBtnState } from "../utils/helpers";
import { clearFormProgress, formProgressSync } from "../utils/formProgress";

const datePicker = document.querySelector("[name='session_date']");
const datePickerErrorEl = document.getElementById("session_date_error");
const timePickerErrorEl = document.getElementById("session_time_error");
const form = document.querySelector("form");
const submitBtn = form.querySelector(".submit-btn");

// const x = getTimePickerValue("x");
// console.log({ x });

const consultationFormId = "book_consultation_form";

// CONVERT ALL SELECT ELEMENTS TO SELECT2 DROPDOWNS AND DISABLE SARCH
$("select").select2({
  minimumResultsForSearch: Infinity
});
// END

// FORM PROGRESS SYNC
formProgressSync(form, consultationFormId);
// FORM PROGRESS SYNC  END

// FLOWBITE DATEPICKER DOES NOT SUPPORT ONCHANGE EVENT
form.addEventListener("submit", async (e) => {
  e.preventDefault();
  //   RESET ERROR TEXTS
  datePickerErrorEl.textContent = "";
  timePickerErrorEl.textContent = "";
  handleSubmitBtnState(submitBtn);
  //  VALIDATE DATE
  const selectedDate = new Date(`${datePicker.value}`);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  console.log(datePicker.value, { selectedDate, currentDate });

  // INPUT VALIDATION
  // IF DATE IS IN THE PAST
  if (selectedDate < currentDate) {
    datePickerErrorEl.textContent = "You cannot select a past date";
    handleSubmitBtnState(submitBtn, false);
    return;
  }

  const dayOfWeek = selectedDate.getDay();
  // IF DATE IS A WEEKEND
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    datePickerErrorEl.textContent =
      "We're available only on weekdays (Monday - Friday)";
    handleSubmitBtnState(submitBtn, false);
    return;
  }

  const { hour, minute, timeString } = getTimePickerValue(
    "consultationTimePicker"
  );

  //   VALIDATE TIME

  //   ACCOUNT FOR MIDNIGHT
  if (hour === 0 || hour < 8 || hour >= 17) {
    timePickerErrorEl.textContent =
      "Office opening hours are 08:00 AM to 5:00 PM";
    handleSubmitBtnState(submitBtn, false);
    return;
  }
  //   handleSubmitBtnState(submitBtn, false);
  //   return;
  // IF TIME IS IN THE PAST - WORK WITH NIGERIA TIMEZONE
  // FACTOR IN TIMEZONE DIFF - THIS IS BECAUSE THE CONSTRUCTED TIMESTAMP WILL RETURN LOCAL TIME (+1 IN WAT) BY DEFAULT
  const now = new Date();
  const watOffset = 60 * 60 * 1000; // WAT is UTC+1
  const currentDateTime = new Date(now.getTime() + watOffset);

  //SET THE TIME TO USER SELECTED DATE AND TIME
  const selectedDateTime = new Date(datePicker.value);
  selectedDateTime.setHours(hour, minute, 0, 0);
  console.log({ selectedDateTime, currentDateTime });

  if (selectedDateTime < currentDateTime) {
    timePickerErrorEl.textContent = "Please select a time in the future";
    handleSubmitBtnState(submitBtn, false);
    return;
  }

  const payload = {};
  const inputEls = form.querySelectorAll("input");
  inputEls.forEach((el) => (payload[el.name] = el.value));
  payload.meeting_type = form.querySelector("[name=meeting_type]").value;
  payload.session_time = timeString;

  try {
    const req = await fetchWithCSRF("", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });

    const res = await req.json();

    // SUCCESS
    if (res.status === "success") {
      let html = `🎉🎉🎉<br />Your meeting with one of our consultants has been scheduled successfully! <br /> <strong>Don't forget to add the date to your calendar</strong> `;
      Swal.fire({
        icon: "success",
        html: `<h5 class='text-base mobile:text-sm'>${html}</h5>`
      });
      clearFormProgress(form, consultationFormId);
      handleSubmitBtnState(submitBtn, false);
    } else if (res.status === "failed") {
      if (res.type === "duplicate_event") {
        let html = `<b>😪Oops</b><br />${res.message}`;
        Swal.fire({
          html: `<h5 class='text-base mobile:text-sm'>${html}</h5>`,
          icon: "error"
        });
        handleSubmitBtnState(submitBtn, false);
      }
    }
  } catch (err) {
    console.log(err);
    handleSubmitBtnState(submitBtn, false);
    Swal.fire({
      html: `<h5 class='text-base mobile:text-sm'><b>Oops!</b> <br />An error occured! Please try again</h5>`,
      icon: "error"
    });
  }
});
